import { render, staticRenderFns } from "./ReportAlertsWidget.vue?vue&type=template&id=7fdb2582&scoped=true&"
import script from "./ReportAlertsWidget.vue?vue&type=script&lang=js&"
export * from "./ReportAlertsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ReportAlertsWidget.vue?vue&type=style&index=0&id=7fdb2582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdb2582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fdb2582')) {
      api.createRecord('7fdb2582', component.options)
    } else {
      api.reload('7fdb2582', component.options)
    }
    module.hot.accept("./ReportAlertsWidget.vue?vue&type=template&id=7fdb2582&scoped=true&", function () {
      api.rerender('7fdb2582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/ReportAlertsWidget.vue"
export default component.exports